<style lang="less" scoped>
</style>
<template>
  <div>
    <v-dialog
      v-model="showModal"
      max-width="500px"
      :persistent="true"
    >
      <v-card>
        <v-card-title>
          <span>提示</span>
        </v-card-title>
        <v-card-text>
          <p>{{ title }}</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="cancel"
          >
            取消
          </v-btn>
          <v-btn
            :loading="loading"
            color="blue darken-1"
            text
            @click="save"
          >
            保存
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  export default {
    props:{
      loading: {
        type:Boolean,
        default:() => false
      },
    },
    data() {
      this.emitData = null
      this.valid = true
      return {
        showModal: false,
        title:''
      }
    },
    computed: {
    },
    methods: {
      save() {
        this.$emit('ok', this.emitData)
      },
      show({props, title}) {
        this.title = title
        this.emitData = props
        this.showModal = true  
      },
      cancel() {
        this.showModal = false  
      }
    }
  }
</script>
